import moment from 'moment';
import { Range } from '../types';
import { isDateBetweenRange } from './dates';

export const getNewRangeExcludingExisitingRange = (
  existingRange: Range,
  rangeToBeChecked: Range,
): Range | undefined => {
  const startDateIsBetween = isDateBetweenRange(rangeToBeChecked.fromDate, {
    startDate: existingRange.fromDate,
    endDate: existingRange.toDate,
  });

  const endDateIsBetween = isDateBetweenRange(rangeToBeChecked.toDate, {
    startDate: existingRange.fromDate,
    endDate: existingRange.toDate,
  });

  if (startDateIsBetween && endDateIsBetween) {
    return undefined;
  }
  if (startDateIsBetween) {
    return {
      fromDate: moment(existingRange.toDate).add(1, 'day'),
      toDate: rangeToBeChecked.toDate,
    };
  }

  if (endDateIsBetween) {
    return {
      fromDate: rangeToBeChecked.fromDate,
      toDate: moment(existingRange.fromDate).subtract(1, 'day'),
    };
  }

  return rangeToBeChecked;
};

export const getNewRangeExcludingExistingRanges = (
  sortedPageParams: Range[],
  rangeToBeChecked: Range,
): Range | undefined =>
  sortedPageParams.reduce((range: Range | undefined, pageParam) => {
    if (range == null) {
      return undefined;
    }

    return getNewRangeExcludingExisitingRange(pageParam, range);
  }, rangeToBeChecked);
